import React, { useContext, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import LocaleContext from '../components/LocaleContext';
import localize from '../components/localize';
import { tr } from '../utils/translations';
import { breakpoints } from '../styles/Variables';
import SEO from '../components/SEO';
import ContactLink from '../components/ContactLink';
import Footer from '../components/Footer';
import { login, logout, isLoggedIn, isLoginError } from '../utils/auth';
import useForm from '../utils/useForm';

const VaultPageStyles = styled.div`
  padding: 3rem var(--col1);
  background-color: var(--green);
  color: var(--peach);
  text-align: center;
  min-height: calc(75vh - var(--navHeight));

  @media (min-width: ${breakpoints.breakMd}) {
    min-height: calc(90vh - var(--navHeight));
    padding-left: var(--col2);
    padding-right: var(--col2);

    h1 {
      font-size: var(--fsTitle1);
    }

    .intro {
      text-align: justify;
    }
  }

  .subheader {
    font-style: italic;
    margin-top: 1rem;
  }

  form {
    margin-bottom: 2rem;
    margin-bottom: 1rem;

    input {
      padding: 0.5em 1em;
      border: 1px solid var(--peach);
      font-family: Avenir, sans-serif;
      font-size: var(--fsButton);

      &[type='password'] {
        width: 100%;
        color: var(--peach);
        text-align: center;
        background: transparent;
        border-radius: 2em;
        margin-bottom: 1rem;

        &::placeholder {
          color: var(--peach);
          font-style: italic;
        }
      }

      &[type='submit'] {
        text-transform: uppercase;
      }
    }
  }

  @media (min-width: ${breakpoints.breakMd}) {
    .subheader {
      margin-top: 3rem;
      margin-bottom: 2rem;
    }

    form {
      margin-bottom: 3rem;

      input {
        display: inline-block;
      }

      input[type='password'] {
        padding-right: 2em;
        text-align: left;
        width: auto;
      }

      input[type='submit'] {
        margin-left: -2em;
      }
    }
  }

  .intro {
    margin-bottom: 2rem;
  }

  .button {
    color: var(--green);
    border-color: var(--peach);
    background-color: var(--peach);

    &.exitVault {
      text-transform: uppercase;
    }
  }

  .mapleSyrup {
    display: none;
  }
`;

const VaultPage = ({ data, pageContext }) => {
  const [locale, setLocale] = useContext(LocaleContext);
  const siteSettings = data.siteSettings.nodes[0];

  const { values, updateValue, clearForm } = useForm({
    password: '',
    message1: '', // THIS IS A HONEY POT, NEVER FILL OUT
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    clearForm();
    login(values, '/vault', '/vault', 'message1');
  };

  const handleLogout = (event) => {
    event.preventDefault();
    logout('/vault');
  };

  return (
    <>
      <SEO
        title={tr('meta', 'vaultTitle', locale)}
        description={tr('meta', 'vaultDescription', locale)}
      />
      <VaultPageStyles>
        <h1>{tr('titles', 'membersVault', locale)}</h1>

        {!isLoggedIn() && (
          <>
            <p className="subheader">
              {tr('notices', 'vaultSubheader', locale)}
            </p>

            {isLoginError() && (
              <p className="subheader">{tr('notices', 'loginError', locale)}</p>
            )}

            <form
              method="post"
              onSubmit={(event) => {
                handleSubmit(event);
              }}
            >
              <input
                type="password"
                name="password"
                onChange={updateValue}
                placeholder={`${tr('titles', 'password', locale)}...`}
              />
              <input
                type="text"
                name="message1"
                className="mapleSyrup"
                onChange={updateValue}
              />
              <input
                type="submit"
                value={tr('cta', 'unlockVault', locale)}
                className="button cta"
              />
            </form>

            <p className="intro">{tr('notices', 'vaultText', locale)}</p>

            <div className="buttonWrapper">
              <a
                href={locale === 'es' ? '/es/?contacto' : '/?contact'}
                className="button cta"
              >
                {tr('titles', 'contactMusa', locale)}
              </a>
            </div>
          </>
        )}
        {isLoggedIn() && (
          <button
            type="button"
            className="button cta exitVault"
            onClick={(event) => handleLogout(event)}
          >
            {tr('cta', 'exitVault', locale)}
          </button>
        )}
      </VaultPageStyles>
      {siteSettings && <Footer siteSettings={siteSettings} />}
    </>
  );
};

// ($imageMaxWidth: Int!)
export const query = graphql`
  query vaultPageQuery {
    siteSettings: allSanitySiteSettings {
      nodes {
        ...SiteSettingsFields
      }
    }
  }
`;

export default localize(VaultPage);
